import React from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

const BackButton = ({ label = "Kthehu në faqen kryesore", className = "" }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={handleBackClick}
      className={`inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 
        bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg 
        hover:bg-gray-50 dark:hover:bg-gray-700 hover:text-customOrange dark:hover:text-customOrange 
        focus:outline-none focus:ring-2 focus:ring-customOrange focus:ring-offset-2 
        transition-all duration-200 shadow-sm hover:shadow-md transform hover:-translate-y-0.5 
        group ${className}`}
    >
      <IoArrowBack className="w-4 h-4 mr-2 transition-transform duration-200 group-hover:-translate-x-1" />
      <span>{label}</span>
    </button>
  );
};

export default BackButton; 